import { useMemo } from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

let hostRegex: RegExp | undefined;

export function normalizeUrl(url: string) {
    if (!hostRegex) {
        hostRegex = new RegExp('^https?://' + window.location.hostname + '(:\\d+)?\\b', 'i');
    }
    const normalized = url.replace(hostRegex!, '');
    const [pathname, search] = normalized.split('?');
    return { pathname, search, normalized };
}

export function Link(props: LinkProps & { to: string; state?: unknown }) {
    const { to } = props;
    const { pathname, search, normalized } = useMemo(() => normalizeUrl(to), [to]);
    if (normalized.includes('://')) {
        return (
            <a {...props} href={normalized}>
                {props.children}
            </a>
        );
    }
    return <RouterLink {...props} state={props.state} to={{ pathname, search }} />;
}
